const itemFlagActions = {
    types: {
        FLAGGED_ITEMS_FOCUS: 'FLAGGED_ITEMS_FOCUS',
        FLAGGED_ITEMS_TOGGLE: 'FLAGGED_ITEMS_TOGGLE',
        FLAGGED_ITEMS_SET: 'FLAGGED_ITEMS_SET',
    },

    /**
     * Sets the flagged status for the given item (contentRevisionId or contentRevisionId-orderNumber)
     * @param {string} identifier
     * @param {boolean} setAsFlagged
     * @returns {{type: string, setAsFlagged: bool, contentRevisionId: int}}
     */
    toggleItemFlag(identifier, setAsFlagged) {
        return { type: this.types.FLAGGED_ITEMS_TOGGLE, setAsFlagged, identifier };
    },

    setFlaggedItems(flaggedItems) {
        return { type: this.types.FLAGGED_ITEMS_SET, flaggedItems };
    },

    focusItemFlag(identifier) {
        return { type: this.types.FLAGGED_ITEMS_FOCUS, identifier };
    },
};

export default itemFlagActions;
